// extracted by mini-css-extract-plugin
module.exports = {"star":"AutoCompleteInput_star__1HsyG","active":"AutoCompleteInput_active__1QgCj","labelActive":"AutoCompleteInput_labelActive__1gqai"};